import React, { useEffect } from 'react';
import storageService, { Locals } from '../../../utils/storageService';
import useCart from '../../../hooks/cart/useCart';
import { isNullOrUndefined } from '../../../utils/utils';
import { useTranslation } from 'react-i18next';
import useShopifyCartSWR from '../../../hooks/shopify/useShopifyCartSWR';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Button, styled, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import useCartUpdate from '../../../hooks/cart/useCartUpdate';

const StyledButton = styled(Button)(({ theme }) => ({
    margin: '0 5px 0 5px',
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    '@media (max-width: 1440px)': {
        margin: '0 -2px 0 -2px',
        fontSize: '0.785rem',
    },
    [theme.breakpoints.down('md')]: {
        margin: '0 5px 0 5px',
        fontSize: '0.875rem',
    },
}));

export const CartMenuItem = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const mdLg = useMediaQuery(theme.breakpoints.up('lg'));

    const cart_token = storageService.getItem(Locals.CART_TOKEN);
    const { cart, isLoading, forceRefresh, isValidating } =
        useShopifyCartSWR(cart_token);
    const cartHook = useCart();
    const cartUpdate = useCartUpdate();

    useEffect(() => {
        if (!isLoading && !isValidating && isNullOrUndefined(cart)) {
            cartHook.createCart().then(() => {
                forceRefresh().then();
            });
        }
    }, [cart, isLoading, isValidating]);

    useEffect(() => {
        forceRefresh().then();
    }, [cartUpdate.needUpdate]);

    return (
        <>
            <Link to={'/cart'}>
                <StyledButton>
                    <ShoppingCartOutlinedIcon
                        fontSize={mdLg ? 'medium' : 'small'}
                    />{' '}
                    {isMobile ? '' : t('HEADER.CART')} (
                    {cart ? cart.totalQuantity : 0})
                </StyledButton>
            </Link>
        </>
    );
};
